import axios from 'axios';

axios.defaults.adapter = ['fetch', 'http', 'xhr'];
axios.defaults.transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: true,
};
